import React, { useEffect, useState, startTransition } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Card, CardContent,Grid } from "@mui/material";
import { format } from "date-fns";
import "react-quill/dist/quill.snow.css";
import { getDossierDetails,linkVisitHistoryUpdate } from "../Dossier/Network_call";
import ActionPlan from "./ActionPlan";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import {Chip} from "@mui/material";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});


const DossierCheck = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dossierData, setDossierData] = useState(null);
  const [dossierNotFound, setDossierNotFound] = useState(false);
  const [err, setErr] = useState(false);
  const [name, setName] = useState("");
  const [implId, setImplId] = useState("");
  const [id, setId] = useState("");
  const [openActionPlanModal, setOpenActionPlanModal] = useState(false);
  
  const queryParams = new URLSearchParams(location.search);
  const data = queryParams.get("data");
  const { journey_type } = useParams();
  

  let customerData = {};
  if (data) {
    try {
      customerData = JSON.parse(decodeURIComponent(data));
    } catch (error) {
      console.error("Failed to parse customer data:", error);
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const name = params.get("name");
    const implId = params.get("impl_id");
    const id = params.get("id");

    setName(name);
    setImplId(implId);
    setId(id);
  }, [location.search]);

  const fetchDossierData = async () => {
    try {
      const result = await getDossierDetails(implId, id);
      if (result.status === 200) {
        let data = result.data;
        if (data.error === "Dossier not found") {
          setDossierNotFound(true);
        } else {
          setDossierData(data);
        }
      } else {
        setErr(true);
      }
    } catch (error) {
      console.error("Error fetching dossier details: ", error);
      setErr(true);
    }
  };

  useEffect(()=>{
    if (implId && id) {
      fetchDossierData();
    }
  },[implId, id]); 

  const handleRedirect = () => {
    navigate(`/user/createdossier/${implId}/${journey_type}/${id}?name=${name}`);
  };

  const handleEditRedirect = () => {
    navigate(`/user/createdossier/${implId}/${journey_type}/${id}?name=${name}`);
  };
  
  const renderContacts = () => {
    if (!dossierData || !dossierData.contacts) return null;

    return (
      <Box sx={{ p: 3, bgcolor: "#ffffff", marginTop: 2 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#00A0B2" }}
        >
          Contacts List
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Persona</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dossierData.contacts.map((contact) => (
                <TableRow key={contact.id}>
                  <TableCell>{contact.name}</TableCell>
                  <TableCell>{contact.persona}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  const renderKeyData = () => {
    if (!dossierData) return null;

  const formatDate = (date) => {
    return date ? format(new Date(date), "dd-MMM-yyyy") : "--";
  };

  const formatValue = (label, value) => {
    if (label === "Campaign Response") {
      return <span dangerouslySetInnerHTML={{ __html: value }} />;
    } else if (["Customer Rating", "Ranking in top 20"].includes(label)) {
      return value || "--"; 
    } else {
      return formatDate(value);
    }
  };
  
    return (
      <Box sx={{ p: 3, marginTop: 2 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#00A0B2" }}
        >
          Key Data
        </Typography>
        <Grid container spacing={2}>
          {dossierData && Object.entries({
            "Became Customer on": dossierData["Became Customer on"],
            "First Purchase": dossierData["First Purchase"],
            "Recent Purchase": dossierData["Recent Purchase"],
            "Customer Rating": dossierData["Customer Rating"],
            "Campaign Response": dossierData["Campaign Response"],
            "Ranking in top 20": dossierData["Ranking"]
          }).map(([label, value]) => (
            <Grid item xs={12} sm={4} key={label}>
              <Card sx={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',  
                }}>
                <CardContent
                sx={{
                  flex: '1 0 auto',  
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',  
                }}>
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>{label}:</strong>
                  </Typography>
                  <Typography variant="body1">
                  {formatValue(label, value)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };

  const handleLinkClick = async (index) => {
    const linkId = index;

    try {
     const response =  await linkVisitHistoryUpdate(linkId);

    } catch (error) {
      console.log(error);
    }
  };

  const renderLinks = () => {
    if (!dossierData || !dossierData.links) return null;
  
    return (
      <Box sx={{ p: 3, bgcolor: "#ffffff", marginTop: 2 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#00A0B2" }}
        >
          Links
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Link Name</TableCell>
                <TableCell>Tags</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dossierData.links.map((link) => (
                <TableRow key={link.id}>
                  {/* <TableCell>{link.name}</TableCell> */}
                  <TableCell>
                    <a href={link.links} target="_blank" rel="noopener noreferrer"
                    onClick={() => handleLinkClick(link.id)} >
                      {link.name}
                    </a>
                  </TableCell>
                  <TableCell>
                    {link.tags?.map((tag) => (
                      <Chip key={tag.id} label={tag.name} sx={{ mr: 1, backgroundColor:"#1FAFC2", borderRadius:"0.5rem" }} />
                    ))}
                </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  

  const renderCustomerAssessment = () => {
    if (!dossierData) return null;
  
    return (
      <Box sx={{ p: 3, marginTop: 2 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#00A0B2" }}
        >
          Customer Assessment
        </Typography>
        <Grid container spacing={2}>
          {dossierData && Object.entries({
            "Profitability": dossierData["Profitability"],
            "Growth Stage": dossierData["Growth Stage"],
            "Current Economic Conditions": dossierData["Current Economic Conditions"],
            "Leadership": dossierData["Leadership"],
            "Change in Resources": dossierData["Change in Resources"],
            "Customers Acquisition Rate": dossierData["Customers Acquisition Rate"]
          }).map(([label, value]) => (
            <Grid item xs={12} sm={4} key={label}>
              <Card
                sx={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',  
                }}
              >
                <CardContent
                  sx={{
                    flex: '1 0 auto',  
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',  
                  }}
                >
                  <Typography variant="subtitle1" gutterBottom>
                    <strong>{label}:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {label.includes("Change in Resources") || label.includes("Customers Acquisition Rate") ? (
                      <span
                        dangerouslySetInnerHTML={{ __html: value }}
                      />
                    ) : (
                      value
                    )}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };
  



  const renderMilestones = () => {
    if (!dossierData || !dossierData.milestones) return null;
  
    const now = new Date();
    const pastEvents = dossierData.milestones.filter((milestone) => new Date(milestone.date) < now);
    const upcomingEvents = dossierData.milestones.filter((milestone) => new Date(milestone.date) >= now);
  
    const renderTable = (events, title) => (
      <Box sx={{ p: 3, bgcolor: "#ffffff", marginTop: 2 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#00A0B2", textAlign: 'center' }}
        >
          {title}
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    width: "150px", 
                    minWidth: "150px",
                  }}
                >
                  Date
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", width: "auto" }} 
                >
                  Summary
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {events.map((milestone, index) => (
                <TableRow key={index}>
                  <TableCell align="center" sx={{ width: "150px", minWidth: "150px" }}>
                    {format(new Date(milestone.date), "dd-MMM-yyyy")}
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      wordBreak: "break-word", 
                      whiteSpace: "normal", 
                    }}
                  >
                    <Typography dangerouslySetInnerHTML={{ __html: milestone.summary }} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  
    return (
      <Box sx={{ marginTop: 4 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            {renderTable(pastEvents, "Past Events")}
          </Grid>
          <Grid item xs={12} sm={6}>
            {renderTable(upcomingEvents, "Upcoming Events")}
          </Grid>
        </Grid>
      </Box>
    );
  };

  
  let lastUpdatedBy = "--";
  let lastUpdatedDate = "--";

if (dossierData && dossierData.updatedHistory && dossierData.updatedHistory.length > 0) {
  const mostRecentUpdate = dossierData.updatedHistory.reduce((latest, record) => {
    const recordDate = new Date(record.updated_at);
    const latestDate = new Date(latest.updated_at);
    return recordDate > latestDate ? record : latest;
  });
  console.log("======",mostRecentUpdate);
  lastUpdatedBy = mostRecentUpdate.user_name;
  const updatedDate = new Date(mostRecentUpdate.updated_at);
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
lastUpdatedDate = updatedDate.toLocaleDateString('en-GB', options);
}

const handleGoBack = () => {
  if (window.history.length > 1) {
    navigate(-1); 
  } else {
    startTransition(() => {
      navigate('/user/findcontact/' + journey_type);
    });
  }
};

  return (
    <>
      <Navbar />
     
      <Box
        sx={{
          padding: "20px",
          margin: "0 auto",
          maxWidth: "900px",
          position: "relative",
        }}
      >
        <Card
            sx={{
              maxWidth: "100%",
              margin: "auto",
              marginTop: "20px",
              marginBottom:"1rem",
              textAlign: "center",
            }}
          >
            <CardContent>
              <Typography
                variant="h4"
                component="div"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#00A0B2" }}
              >
                {decodeURIComponent(name)}
              </Typography>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <Grid item>
                  <Typography variant="body2" component="div">
                    <span style={{ color: "#FF762B" }}>Last Updated by:</span>{" "}
                    {lastUpdatedBy}
                  </Typography>
                </Grid>
                <Grid item sx={{ color: "#FF762B" }}>
                  <CalendarTodayIcon fontSize="small" />
                </Grid>
                <Grid item>
                  <Typography variant="body2" component="div">
                    <span style={{ color: "#FF762B" }}>Last Updated Date:</span>{" "}
                    {lastUpdatedDate}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        {dossierNotFound ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Typography variant="h6" component="div" gutterBottom>
              <span style={{ color: "#1FAFC2" }}>
                No <span style={{ color: "#FF762B" }}>Dossier Details </span> Found
              </span>
            </Typography>
            <Button
              onClick={handleRedirect}
              sx={{
                backgroundColor: "#1FAFC2",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1FAFC2",
                  color: "white",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              Go to Create Dossier
            </Button>
          </Box>
        ) : dossierData ? (
          <>
          
            <Box sx={{ display: "flex", gap: 2 }}>
            <Button
                variant="contained"
                color="primary"
                onClick={handleGoBack}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleEditRedirect}
              >
                Edit Dossier
              </Button>
              
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpenActionPlanModal(true)}
              >
                View Action Plan 
                </Button>
            </Box>
            {renderContacts()}
            {renderLinks()}
            {renderMilestones()}
            {renderKeyData()}
            {renderCustomerAssessment()}

        <Dialog
          open={openActionPlanModal}
          onClose={() => setOpenActionPlanModal(false)}
          fullWidth
          maxWidth="md"
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
              position: 'absolute',
              right: 0,
              bottom: 0,
              top: 0,
              maxHeight: '100vh',
              overflow: 'hidden',
              width:'32rem',
              height:'100vh',
              marginTop:'0rem',
              marginRight:'0rem',
              borderRadius:'0rem'
              
            }
          }}
        >
          <DialogContent>
            <ActionPlan dossierData={dossierData} refreshDossierDetails={fetchDossierData}/>
          </DialogContent>
          <DialogActions>
          

          <FontAwesomeIcon icon={faXmark} onClick={() => setOpenActionPlanModal(false)} style={{position:"absolute",right:'2rem', top:'3rem',fontSize:"1.5rem"}} />

            
         
          </DialogActions>
        </Dialog>
          </>
        ) : err ? (
          <Typography variant="h6" component="div" gutterBottom>
            Error fetching dossier details.
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              component="div"
              gutterBottom
              sx={{ display: "flex", justifyItems: "center", alignItems: "center" }}
            >
              <CircularProgress sx={{ color: "#1FAFC2", marginLeft: "8px" }} />
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export default DossierCheck;




